import Script from 'next/script';

export const OneTrustScripts = () => {
  if (process.env.COOKIE_BANNER_DISABLED === 'true') return null;

  // eslint-disable-next-line @opendoor/no-direct-env-check
  const isProduction = process.env.NEXT_PUBLIC_DEPLOY_ENV === 'production';
  const domainScript = isProduction
    ? '019756e6-db1e-7dfa-97f3-4cf089c9f913'
    : '019756e6-db1e-7dfa-97f3-4cf089c9f913-test';

  return (
    <>
      <Script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        strategy="lazyOnload"
        data-domain-script={domainScript}
      />
      <Script id="optanon-wrapper" strategy="lazyOnload">
        {`function OptanonWrapper() { }`}
      </Script>
    </>
  );
};
